

import Vue from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { SelectModel } from  '@/models/repsol-template.model';
import { _DYN_INDEX_OF } from '@microsoft/applicationinsights-web/types/__DynamicConstants';
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolDualListComponent',
    components: {}
})

export default class RepsolDualListComponent extends Vue {
    isOpen = false;

    @Prop()
    title: string;

    @Prop()
    source: SelectModel[];

    @Prop()
    destination: string[];

    @Prop()
    disabled: boolean;

    translate(value: string, params?: Record<string, unknown>): string {
        return tUi(value, params);
    }

    sourceSelected: string[] = [];
    destinationSelected: string[] = [];

    sourceFilter(): SelectModel[] {
        if(!this.destination)
            return this.source;

        return this.source.filter(s => this.destination.indexOf(s.id) === -1);
    }

    destinationFilter(): SelectModel[] {
        if(!this.destination)
            return [];

        return this.source.filter(s => this.destination.indexOf(s.id) !== -1);
    }

    moveDestination() {
        let selected = this.source.filter(f =>  this.sourceSelected.indexOf(f.id) !== -1);

        selected.forEach(element => {
            this.destination.push(element.id);
        });

        this.sourceSelected = [];
    }

    moveSource() {
        for (let i = 0; i < this.destinationSelected.length; i++) {
            const element = this.destinationSelected[i];
            this.$delete(this.destination, this.destinationSelected.indexOf(element))
        }


        // let selected = this.destination.filter(f => this.destinationSelected.indexOf(f.id) !== -1).map(f => f.id);

        // this.destination = this.destination.filter(f => selected.indexOf(f.id) !== -1);
        this.destinationSelected = [];
    }

    moveAllDestination() {
        var sourceFiltered = this.sourceFilter();
        sourceFiltered.forEach(element => {
            this.destination.push(element.id);
        });
        this.sourceSelected =[];
        this.destinationSelected = [];
    }

    moveAllSource() {
        while(this.destination.length > 0){
            this.$delete(this.destination, 0);
        }
        this.sourceSelected =[];
        this.destinationSelected = [];
    }

    selectDestination(key) {
        if(this.disabled) return;
        var pos = this.destinationSelected.indexOf(key.id);
        if(pos === -1){
            this.destinationSelected.push(key.id);
        }else{
            delete this.destinationSelected[pos];
        }
    }

    selectSource(key) {
        if(this.disabled) return;
        var pos = this.sourceSelected.indexOf(key.id);
        if(pos === -1){
            this.sourceSelected.push(key.id);
        }else{
            delete this.sourceSelected[pos];
        }
    }

    // selectAllSource() {
    //     this.source = this.source.map(item => ({ ...item, selected: true }));
    //     this.$emit("onChangeList", {
    //         key: this.primarykey,
    //         destination: this.destination
    //     },);
    // }

    // deSelectAllSource() {
    //     this.source = this.source.map(item => ({ ...item, selected: false }));
    //     this.$emit("onChangeList", {
    //         key: this.primarykey,
    //         destination: this.destination
    //     },);
    // }

    // selectAllDestination() {
    //     this.destination = this.destination.map(item => ({
    //         ...item,
    //         selected: true
    //     }));
    //     this.$emit("onChangeList", {
    //         key: this.primarykey,
    //         destination: this.destination
    //     },);
    // }

    // deSelectAllDestination() {
    //     this.destination = this.destination.map(item => ({
    //         ...item,
    //         selected: false
    //     }));
    //     this.$emit("onChangeList", {
    //         key: this.primarykey,
    //         destination: this.destination
    //     },);
    // }
}

Vue.component('repsol-dual-list', RepsolDualListComponent);
